<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            <!-- {{ $t('company.vision.title') }} -->
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('hardwer.service.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('hardwer.service.text.01')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify py-0">
            {{ $t('hardwer.service.text.02')}}
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'ItService',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
